module.exports = __webpack_public_path__ + "img/top-bar-icon-home.3f7a1dbf.svg";